import axiosInstance from './axiosInstance';

const API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';


export const getByPublicationIdAndUserIdAndPage = async (publicationid, page, token) => {
  try {
    const response = await axiosInstance.get(
      `publicationanduserpagelog/getByPublicationIdAndUserIdAndPage/${publicationid}/${page}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching logs by publication + page:', error);
    throw error;
  }
};


export const getByPublicationIdAndUserId = async (publicationid, token) => {
  try {
    const response = await axiosInstance.get(
      `publicationanduserpagelog/getByPublicationIdAndUserId/${publicationid}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching logs by publication:', error);
    throw error;
  }
};


export const createPublicationPdfLog = async (publicationid, page, token) => {
  try {
    const response = await axiosInstance.get(
      `publicationanduserpagelog/create/${publicationid}/${page}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error creating publication pdf log:', error);
    throw error;
  }
};

export const createPublicationPdfLogRange = (publicationid, startpage, endpage, token) => {
  return axiosInstance.get(
    `publicationanduserpagelog/createPageRange/${publicationid}/${startpage}/${endpage}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
};

export const setVisitedPageLog = async (publicationid, page, token) => {
  try {
    const response = await axiosInstance.post(
      `publicationlogs/setVisitedLog`,
      {
        publicationid: Number(publicationid),
        visitedtype: "page",
        pagenumber: Number(page)
      },
      {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error setting visited page log:', error);
    throw error;
  }
};


const publicationAndUserPageLogService = {
  getByPublicationIdAndUserIdAndPage,
  getByPublicationIdAndUserId,
  createPublicationPdfLog,
  createPublicationPdfLogRange,
  setVisitedPageLog
};

export default publicationAndUserPageLogService;

